webpackJsonp([37],{

/***/ 1529:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_property_records_models_page__ = __webpack_require__(1607);


(function Page(PROPERTY_RECORDS) {

  var init = function init(options) {
    var data = (options || {}).data || MOVE.DataStore.getData('propertyRecords');
    PROPERTY_RECORDS.model = new __WEBPACK_IMPORTED_MODULE_0_property_records_models_page__["a" /* PropertyRecordsModel */](options || { data: data });
  };

  PROPERTY_RECORDS.page = {
    init: init
  };
})(MOVE.PropertyRecords);

/***/ }),

/***/ 1530:
/***/ (function(module, exports) {

MOVE.PropertyRecords = function (MOVE) {
  var init = function init() {};

  MOVE.PropertyRecords = {
    init: init
  };

  return MOVE.PropertyRecords;
}(MOVE || {});

/***/ }),

/***/ 1607:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PropertyRecordsModel; });
var PropertyRecordsModel = function PropertyRecordsModel(options) {
  this.data = options.data;
  this.getData = function () {
    return this.data;
  };
};



/***/ }),

/***/ 1675:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__application_critical__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_property_records_page__ = __webpack_require__(1530);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_property_records_page___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_property_records_page__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_property_records_controllers_page__ = __webpack_require__(1529);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_app__);





/***/ }),

/***/ 19:
/***/ (function(module, exports) {

(function () {

    //bootstrap application
    MOVE.init();
})();

/***/ })

},[1675]);


// WEBPACK FOOTER //
// property_records_critical-1b7e4c27f679944365f6.js